import { adminRpc } from "../../../services/admin-rpc-client";

// Where the Run as options come from.
//
// The AUTHORITY on which users a job may run as is the host's executor policy
// (proxmox-hosts single-flake/components/job-executor.nix, policy.allowedUsers) — nix
// config the UI cannot read. But a run-as user must also be an ONBOARDED WORKER: the
// executor launches the job as that user and the job reports through that user's own a8
// and bootstrap.conf (depot seeds `pgbackrest` exactly so, a8.seed.users.pgbackrest). So
// continuum already knows the plausible accounts on a host — they are the worker rows
// sharing the job's server — and that is what the picker offers.
//
// The list is therefore a strong suggestion, not a permission check. The executor still
// refuses a user its policy has not been granted, which is the right place for that to be
// decided. FEATURE-20260822-job-executor-run-jobs-as-other-users Part B moves the grants
// themselves into continuum; when it lands, this query becomes a read of the grants and
// the list turns into the actual permitted set.

const esc = (s: string) => s.replace(/'/g, "''");

/** The unix logins of every worker on the same server as `workerUid`. */
export async function runAsCandidates(workerUid: string): Promise<string[]> {
  if (!workerUid) return [];
  const resp = await adminRpc.query(
    `SELECT w2.login FROM worker w1 JOIN worker w2 ON w2.serveruid = w1.serveruid ` +
      `WHERE w1.uid = '${esc(workerUid)}' ORDER BY w2.login`,
  );
  return resp.rows.map((r) => String(r["login"] ?? "")).filter(Boolean);
}
